import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { obterConfirmacaoSimulacao, confirmarSimulacao } from "../services/api";
import { abrirSala } from "../services/abrirSala";

// 🌐 CONFIRMAÇÃO da simulação sem conta (23/10/2026). Abrir a página NÃO confirma nada (o antivírus do e-mail abre
// os links sozinho): só o clique em "Confirmar e enviar o convite" ativa a sala e manda os convites.
export default function SimulacaoConfirmarPage() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [erro, setErro] = useState("");
  const [feito, setFeito] = useState(null);
  const [enviando, setEnviando] = useState(false);
  useEffect(() => {
    document.title = "Confirme a sua simulação · eaiRH";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
  useEffect(() => {
    if (!token) { setErro("Link incompleto. Abra pelo botão do e-mail."); return; }
    obterConfirmacaoSimulacao(token).then(setInfo).catch((e) => setErro(e.message));
  }, [token]);
  const confirmar = async () => {
    setErro(""); setEnviando(true);
    try { setFeito(await confirmarSimulacao(token)); } catch (e) { setErro(e.message); } finally { setEnviando(false); }
  };
  const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "long", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-extrabold text-text">🧪 Confirmar a entrevista de teste</h1>
        {erro && <p className="mt-4 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {!info && !erro && <p className="mt-4 text-sm text-gray-500">Conferindo o link…</p>}
        {info && !feito && (
          <section className="bg-white rounded-2xl shadow-sm p-5 mt-4 text-sm">
            <p>Olá, <b>{info.nome}</b>! Teste com <b>{info.colega}</b> ({info.emailColega}){info.empresa ? <> · {info.empresa}</> : null}.</p>
            <p className="mt-1 text-gray-700">{info.agoraMesmo ? "Começa assim que você confirmar." : `Quando: ${quando(info.inicio)}.`} A conversa dura até {info.duracaoMin} minutos.</p>
            {info.expirada ? (
              <p className="mt-3 rounded-xl bg-slate-50 border px-3 py-2">Este link expirou (24 horas). <Link to="/simulacao" className="text-primary underline">Peça o teste de novo</Link>.</p>
            ) : info.confirmada ? (
              <p className="mt-3 text-gray-600">Já confirmado. <button onClick={confirmar} className="text-primary underline font-semibold">Mostrar o meu link da sala</button></p>
            ) : (
              <button onClick={confirmar} disabled={enviando} className="mt-4 rounded-lg bg-accent hover:opacity-90 disabled:opacity-40 text-white font-semibold px-5 py-2.5">
                {enviando ? "Confirmando…" : "Confirmar e enviar o convite"}
              </button>
            )}
          </section>
        )}
        {feito && (
          <section className="rounded-2xl border border-green-200 bg-green-50 p-5 mt-4 text-sm text-green-900">
            <p className="font-bold">✅ {feito.jaConfirmada ? "Já estava confirmado." : "Confirmado! O convite foi para o seu colega."}</p>
            <p className="mt-1">Você também recebeu por e-mail o convite com o seu link (é só seu, não precisa de conta). A sala abre 15 minutos antes e a conversa dura até 15 minutos.</p>
            {feito.linkEntrevistador && (
              <a href={feito.linkEntrevistador} onClick={(ev) => abrirSala(ev, feito.linkEntrevistador)}
                className="inline-block mt-3 bg-brand text-white font-bold rounded-lg px-4 py-2">Entrar na sala</a>
            )}
          </section>
        )}
      </main>
    </div>
  );
}
